<div class="composition-bar" [style.height]="height" [pTooltip]="tooltip" tooltipPosition="top">
  <span
    class="composition-bar__segment composition-bar__segment--pending"
    [style.width.%]="percent(pending)"></span>
  <span
    class="composition-bar__segment composition-bar__segment--approved"
    [style.width.%]="percent(approved)"></span>
  <span
    class="composition-bar__segment composition-bar__segment--rejected"
    [style.width.%]="percent(rejected)"></span>
</div>
